import { call, put, select, takeLatest } from 'redux-saga/effects';

import AMPLITUDE_EVENT_NAMES from '../../../amplitude/constants';
import {
  ACTIVE_EVENT_UPDATED,
  EVENT_CREATED,
  saveEventSuccess
} from '../../actions/events';
import { COLLECTION } from '../../../constants/collection';
import { FIELDS } from '../../../constants/eventForm';
import {
  getActiveManageEventId,
  getCreateFormValues,
  getUpdateFormValues
} from '../selectors';
import { logAmplitudeEvent } from '../../actions/amplitude';
import store from '../../store/store';
import { updateActiveEventPosterIfChanged } from './utils/file';
import { uploadFile } from './utils/file';
import { validateUser } from './utils/auth';

const createEvent = function* createEvent() {
  const authUser = yield call(validateUser);
  let values = yield select(getCreateFormValues);
  values[FIELDS.OWNER] = authUser.uid;
  values = yield call(uploadFile, values, authUser.uid);
  const createdEvent = yield store.firestore.add(
    { collection: COLLECTION.EVENTS },
    values,
  );
  yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.EVENT_CREATED, {
    id: createdEvent.id,
    categories: Object.keys(values[FIELDS.CATEGORIES]),
    title: values[FIELDS.TITLE],
  }));
  yield put(saveEventSuccess(createdEvent.id));
};

const watchCreateEvent = function* watchCreateEvent() {
  yield takeLatest(EVENT_CREATED, createEvent);
};

const updateActiveEvent = function* updateActiveEvent() {
  const authUser = yield call(validateUser);
  const activeManageEventId = yield select(getActiveManageEventId);

  let values = yield select(getUpdateFormValues);
  values = yield updateActiveEventPosterIfChanged(values, authUser.uid);

  yield store.firestore.update(
    { collection: COLLECTION.EVENTS, doc: activeManageEventId },
    values,
  );
  yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.EVENT_UPDATED, {
    id: activeManageEventId,
    categories: Object.keys(values[FIELDS.CATEGORIES]),
    title: values[FIELDS.TITLE],
  }));
  yield put(saveEventSuccess(activeManageEventId));
};

const watchUpdateActiveEvent = function* watchUpdateActiveEvent() {
  yield takeLatest(ACTIVE_EVENT_UPDATED, updateActiveEvent);
};

export {
  watchCreateEvent,
  watchUpdateActiveEvent,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/events/save.js